module.exports = "https://web-assets.ifttt.com/packs/media/service_icons/dominos-8e3e2299.svg";